import React, {Fragment, useEffect, useState} from "react";
import Api from "../../Api";
import {FormattedMessage, useIntl} from "react-intl";
import {InputHelper} from "../../Components/Utils/FieldsHelper";
var generator = {
    generate: function (opts) {
        var length = (opts && opts.length) || 10;
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        if (opts && opts.numbers) chars += "0123456789";
        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
        var result = "";
        var array = new Uint32Array(length);
        window.crypto.getRandomValues(array);
        for (var i = 0; i < length; i++) {
            result += chars[array[i] % chars.length];
        }
        return result;
    }
};

import Modal from "../../Components/Utils/Modal";
import Icon from "../../Components/Utils/Icon";
import Button from "../../Components/Utils/UI/Button";

import classes from "./styles.module.css";


function General({token, logout, forcedPasswordChange, onMessage}) {

    const intl = useIntl();

    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [form, setForm] = useState({email: "", password: "", firstName: "", lastName: "", patronymic: ""});
    const [initEmail, setInitEmail] = useState(null);

    function onModalClose() {
        setIsOpenModal(false);
        setIsLoading(false);
    }

    function confirmChanges() {
        if (form.password || form.email !== initEmail)
            setIsOpenModal(true);
    }

    useEffect(() => {
        new Api({token}).getUserData().then(r => {
            setForm({...form, email: r.email, firstName: r.firstName, lastName: r.lastName, patronymic: r.patronymic});
            setInitEmail(r.email);
        });
    }, [])

    function onChangeForm(name, value) {
        setForm({...form, [name]: value});
    }

    function cleanPassword() {
        setForm({...form, password: ""});
    }

    function generatePassword() {
        setForm({
            ...form, password: generator.generate({
                length: 10,
                numbers: true,
                symbols: true
            })
        })
    }

    function saveChanges() {

        setIsOpenModal(false);
        setIsLoading(true);

        const email = form.email;

        new Api({token}).setUserData(form).then(r => {

            if (r.error) {
                onMessage({
                    type: "error",
                    message: "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."
                });
                setIsLoading(false);
                return;
            }

            if (form.password) {
                logout();
                return;
            }

            // Смена почты не применяется сразу: сервер шлёт письмо на новый адрес
            // и ждёт перехода по ссылке. Писать «Успех» было бы неправдой — адрес
            // пока прежний.
            if (r.emailConfirmationPending) {
                onMessage(r.emailConfirmationSent === false
                    ? {
                        type: "error",
                        message: intl.formatMessage({
                            id: "Profile.error.emailConfirmationNotSent",
                            defaultMessage: "Не удалось отправить письмо на {email}. Почта пока прежняя — попробуйте сменить её позже или напишите в поддержку."
                        }, {email})
                    }
                    : {
                        type: "success",
                        message: intl.formatMessage({
                            id: "Profile.success.emailConfirmationPending",
                            defaultMessage: "Мы отправили письмо на {email}. Адрес сменится после перехода по ссылке из письма."
                        }, {email})
                    });

                // Без этого следующее «Сохранить» снова считало бы почту
                // изменённой и отправляло новое письмо.
                setInitEmail(email);
            } else {
                onMessage({type: "success", message: "Успех. Вы успешно сохранили форму."});
            }

            setIsLoading(false);
        }).catch(() => {
            // Ответ 422 (например, короткий пароль) раньше не ловился, и форма
            // навсегда оставалась в загрузке.
            onMessage({
                type: "error",
                message: "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."
            });
            setIsLoading(false);
        });
    }

    return (
        <Fragment>

            <Modal title="Изменение данных" isOpen={isOpenModal} onClose={() => onModalClose()}
                   onConfirm={() => saveChanges()} isConfirm>

                {form.password &&
                    <p className={classes.ModalText}>
                        <FormattedMessage
                            id="Profile.text.changePassword"
                            values={{password: <b>{form.password}</b>}}
                            defaultMessage="Пароль учетной записи был изменен. После подтверждения Вы будете
                                     разлогинены на всех устройствах. Перед подтверждением запишите и сохраните в надежном
                                     месте новый пароль: {password}"
                        />
                    </p>
                }

                {form.email !== initEmail &&
                    <p className={classes.ModalText}>
                        <FormattedMessage
                            id="Profile.text.changeEmail"
                            values={{email: <b>{form.email}</b>}}
                            defaultMessage="Почтовый адрес учетной записи был изменен. После подтверждения на адрес {email} будет выслано письмо с дальнейшими инструкциями."
                        />
                    </p>
                }
            </Modal>

            <div className={classes.Column}>

                <h3 className={classes.Title}>Личные данные</h3>

                <p className={classes.Text}>Для смены ФИО обратитесь в техническую поддержку.</p>

                <div className={classes.InputWrap}>

                    <InputHelper
                        onChange={onChangeForm}
                        value={form.email}
                        placeholder={"example@email.ru"}
                        fieldName={"email"}
                        label={"FieldsHelper.label.email"}
                        changeRegexp={/[^A-Za-z0-9\s_@.]+/g}
                        blurRegexp={/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                        changeMessage={"FieldsHelper.error.charactersEmail"}
                        blurMessage={"FieldsHelper.error.checkEmail"}
                        isDisabled={isLoading}
                        autoComplete="off"
                    />
                </div>

                <div className={classes.InputWrap}>
                    <label className={classes.Label}>Фамилия</label>
                    <input className={classes.Input} defaultValue={form.lastName} readOnly={true} disabled={true}/>
                </div>

                <div className={classes.InputWrap}>
                    <label className={classes.Label}>Имя</label>
                    <input className={classes.Input} defaultValue={form.firstName} readOnly={true} disabled={true}/>
                </div>

                <div className={classes.InputWrap}>
                    <label className={classes.Label}>Отчество</label>
                    <input className={classes.Input} defaultValue={form.patronymic} readOnly={true} disabled={true}/>
                </div>
            </div>

            <div className={classes.Column}>
                {forcedPasswordChange &&
                    <div className={classes.Attention}>
                        <Icon className={classes.AttentionIcon} icon="warning" size={'25px'}/>
                        Для получения полного функционала личного кабинета необходимо изменить пароль учетной записи.
                        Воспользуйтесь генератором пароля и сохраните новый пароль в надежном месте.
                    </div>}

                <h3 className={classes.Title}>Cмена пароля</h3>

                <p className={classes.Text}>После смены пароля произойдёт выход из аккаунта на всех устройствах.</p>

                <div className={classes.InputWrap}>
                    <div className={classes.InputHeader}>
                        <label className={classes.Label}>Пароль</label>
                        <span className={classes.InputLink} onClick={() => {
                            !isLoading && cleanPassword()
                        }}>
                            <Icon className={classes.LinkIcon} icon={"close"} size={"12px"}/>
                            Отменить изменения
                        </span>
                    </div>
                    <input className={classes.Input} placeholder="••••••••••" value={form.password} readOnly={true}
                           disabled={isLoading}/>
                    <button className={classes.Btn} onClick={() => {
                        !isLoading && generatePassword()
                    }}>Генератор пароля
                    </button>
                </div>
            </div>

            <Button label={"Profile.btn.save"} onClick={confirmChanges} icon={"document-edit"} isLoading={isLoading}/>
        </Fragment>
    )
}

export default General;


// WEBPACK FOOTER //
// ./src/PagesOfUser/Profile/General.js